import { setup } from 'xstate';

import { useMachine } from '@xstate/react';
import * as React from 'react';

function convertPixelToSvgCoord(event: PointerEvent, el = event.currentTarget as SVGGElement) {
  const svg = el.ownerSVGElement!;
  let p = svg.createSVGPoint();
  p.x = event.clientX;
  p.y = event.clientY;
  p = p.matrixTransform(svg.getScreenCTM()?.inverse());
  return p;
}

const machine = setup({
  types: {} as {
    context: {
      el?: SVGGElement;
    };
    events:
      | {
          type: 'pointerdown';
          event: PointerEvent;
          el: SVGGElement;
        }
      | {
          type: 'pointermove';
          event: PointerEvent;
        }
      | {
          type: 'pointerup';
          event: PointerEvent;
        };
  },
  actions: {},
}).createMachine({
  id: 'Pointer events',
  initial: 'not_dragging',
  states: {
    not_dragging: {
      on: {
        pointerdown: {
          target: 'dragging',
          actions: [
            ({ context, event: { el } }) => {
              context.el = el;
            },
          ],
        },
      },
    },
    dragging: {
      on: {
        pointermove: {
          actions: [
            ({ context: { el }, event: { event } }) => {
              if (el) {
                // console.log('mousedown', { event });
                const { x, y } = convertPixelToSvgCoord(event, el);
                el.setAttribute('transform', `translate(${x}, ${y})`);
              }
            },
          ],
        },
        pointerup: {
          target: 'not_dragging',
          actions: [
            ({ context }) => {
              context.el = undefined;
            },
          ],
        },
      },
    },
  },
});

function ByPointerEvent() {
  const [state, send] = useMachine(machine);
  const refG = React.useRef<SVGGElement>(null);
  React.useEffect(() => {
    const el = refG.current!;
    function pointerdown(event: PointerEvent) {
      send({ type: 'pointerdown', event, el });
    }
    function pointermove(event: PointerEvent) {
      send({ type: 'pointermove', event });
    }
    function pointerup(event: PointerEvent) {
      send({ type: 'pointerup', event });
    }
    el.addEventListener('pointerdown', pointerdown);
    el.addEventListener('pointermove', pointermove);
    el.addEventListener('pointerup', pointerup);
    el.addEventListener('pointercancel', pointerup);
    return () => {
      el.removeEventListener('pointerdown', pointerdown);
      el.removeEventListener('pointermove', pointermove);
      el.removeEventListener('pointerup', pointerup);
      el.removeEventListener('pointercancel', pointerup);
    };
  }, []);
  // console.log('MouseOnlyXState', { state });
  return (
    <div className="container rounded border border-current relative mb-10">
      <div className="absolute" style={{ left: '50%', transform: 'translateX(-50%)' }}>
        <div className="backdrop-brightness-90 p-1 rounded-md">{state.value}</div>
      </div>
      <svg viewBox="0 0 300 100">
        <g ref={refG} className="cursor-grab" transform="translate(30, 30)">
          <circle cx={0} cy={0} stroke="black" r="30"></circle>
          <g fontSize="14" textAnchor="middle" fill="white">
            <text dy="0.0em">Drag</text>
            <text dy="1.0em">me</text>
          </g>
        </g>
      </svg>
    </div>
  );
}

export default React.memo(ByPointerEvent);
